import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandM } from '@sorare/core/src/atoms/typography';
import { NeonEdge as NeonEdgeAtom } from '@sorare/core/src/atoms/ui/NeonEdge';
import { DialogKey } from '@sorare/core/src/components/navigation/WithDialogs';
import { useOpenDialog } from '@sorare/core/src/hooks/navigation/useOpenDialog';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import gems from 'assets/gems/gems.webp';

const Root = styled(ButtonBase)`
  position: relative;
  isolation: isolate;
  background: repeating-linear-gradient(
      to left,
      var(--c-nd-150) 0px,
      var(--c-nd-150) 1px,
      transparent 1px,
      transparent var(--double-and-a-half-unit)
    ),
    repeating-linear-gradient(
      to bottom,
      var(--c-nd-150) 0px,
      var(--c-nd-150) 1px,
      transparent 1px,
      transparent var(--double-and-a-half-unit)
    ),
    linear-gradient(180deg, #284b30 0%, rgba(0, 0, 0, 0.7) 100%);
  border-radius: var(--double-unit);
  border: 1px solid var(--c-nd-150);
  overflow: hidden;
`;

const NeonEdge = styled(NeonEdgeAtom)`
  width: 100%;
`;
const Main = styled(Vertical).attrs({ gap: 2 })`
  width: 100%;
  padding: var(--double-unit);
  position: relative;
  z-index: 2;
  @media ${laptopAndAbove} {
    padding: var(--triple-unit);
  }
`;

const Img = styled.img`
  width: calc(12 * var(--unit));
  height: calc(12 * var(--unit));
  object-fit: contain;
  object-position: center;
  margin: 0 auto;
`;

export const BuyGemsButtonBlock = () => {
  const openDialog = useOpenDialog();
  return (
    <Root onClick={() => openDialog(DialogKey.buyGems, 'true')}>
      <NeonEdge side="top" showNeon="always" color="#8CE456">
        <Main>
          <BrandM bold>
            <FormattedMessage
              id="BuyGemsButtonBlock.title"
              defaultMessage="Gems"
            />
          </BrandM>

          <Img src={gems} alt="Gems" />
        </Main>
      </NeonEdge>
    </Root>
  );
};
